import './FilterMapAreaControls.css';
import React from 'react';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'FilterMapAreaControls');

export function FilterMapAreaControls({
    children
}: {
    children?: React.ReactNode;
}) {
    return (
        <div className={cn()}>
            {children}
        </div>
    );
}
